import HttpClient from './httpClient';

export interface IRecentSupplyChainService {
  uuid: string;
  pedido: string;
  bl: string;
  invoice: string;
  status: string;
  liberado_download: string;
  cliente: string;
  created_at: string;
}

export interface IDashboardImporterIndicatorsService {
  total_supply_chains: number;
  pending_release: number;
  released: number;
  recent_supply_chains: IRecentSupplyChainService[];
}

class DashboardImporterService {
  static async getIndicators(): Promise<IDashboardImporterIndicatorsService> {
    const { data } = await HttpClient.api.get('/importers/dashboard');
    return data.data;
  }
}

export default DashboardImporterService;
